import { $qs, $qsa } from "./utils/QuerySelector";
import $tc from "../../tailwind.config";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function menu() {
	const mainMenu = $qs("#main-menu");
	const mainMenu__hasChildren = $qsa(
		"#main-menu > .menu-item-has-children > a"
	);
	const subMenu__subMenuTrigger = $qsa(
		".menu-item-has-children > a > .submenu-trigger",
		mainMenu
	);

	const navigationBar = $qs('[data-name="navigation-bar"]');
	const subMenus = $qsa('[data-name="main-menu__sub"]');

	const hamburgerSlices = $qsa('[data-name="hamburgerSlice"]');
	const mainMenuToggle = $qs('[data-name="mainMenuToggle"]');
	const mobile_menu = $qsa('[data-target="mobile_menu"]');

	const menu_bar = $qs('[data-target="menu_bar"]');
	const backmenu = $qsa('[data-target="backmenu"]');
	const mqlg = window.matchMedia("(min-width: 1280px)");

	let tl = gsap.timeline({
		scrollTrigger: {
			trigger: "body",
			start: "70px top",
			// end: "bottom bottom",
			// end: window.innerHeight * 2,
		},
	});

	subMenu__subMenuTrigger.forEach((item) => {
		item.addEventListener("click", function (e) {
			e.preventDefault();
			console.log(item);
			navigationBar.dataset.state = "open";

			const level3Submenu = $qs(".level-3-submenu", item.parentNode.parentNode);
			if (level3Submenu) {
				if (!mqlg.matches) {
					// Mobile behavior
					// Check if this submenu is already open
					const isOpen = level3Submenu.classList.contains("active");

					// First close all other level 3 submenus and reset their triggers
					const allLevel3 = $qsa(".level-3-submenu");
					allLevel3.forEach((submenu) => {
						if (submenu !== level3Submenu) {
							submenu.classList.remove("active");
							const trigger = submenu.previousElementSibling;
							if (trigger) trigger.classList.remove("active");
							gsap.to(submenu, {
								height: 0,
								autoAlpha: 0,
								duration: 0.3,
								ease: "power2.inOut",
								onComplete: () => {
									submenu.style.visibility = "hidden";
								},
							});
						}
					});

					// Toggle the clicked submenu
					if (isOpen) {
						// Close this submenu
						level3Submenu.classList.remove("active");
						item.classList.remove("active");
						gsap.to(level3Submenu, {
							height: 0,
							autoAlpha: 0,
							duration: 0.3,
							ease: "power2.inOut",
							onComplete: () => {
								level3Submenu.style.visibility = "hidden";
							},
						});
					} else {
						// Open this submenu
						level3Submenu.classList.add("active");
						item.classList.add("active");
						gsap.set(level3Submenu, {
							autoAlpha: 1,
							visibility: "visible",
						});
						level3Submenu.style.height = "auto";
						const height = level3Submenu.offsetHeight;
						level3Submenu.style.height = "0px";

						gsap.to(level3Submenu, {
							height: height,
							autoAlpha: 1,
							duration: 0.3,
							ease: "power2.inOut",
							onComplete: () => {
								level3Submenu.style.height = "auto";
							},
						});
					}
				} else {
					// Desktop behavior (unchanged)
					gsap.to(".level-3-submenu", { autoAlpha: 0 });
					gsap.to(level3Submenu, { autoAlpha: 1, duration: 0.5 });
				}
			}
		});
	});
	mainMenu__hasChildren.forEach((item) => {
		item.addEventListener("click", function (e) {
			e.preventDefault();
			navigationBar.dataset.state = "open";
			const allLevel3Menus = $qsa(".level-3-submenu");
			allLevel3Menus.forEach((menu) => {
				menu.classList.remove("active");
				gsap.set(menu, {
					autoAlpha: 0,
					visibility: "hidden",
				});
			});

			const subMenu = $qs('[data-name="main-menu__sub"]', item.parentNode);
			const subMenuContainers = $qsa(
				'[data-name="main-menu__sub"] .menu_inside',
				item.parentNode
			);

			// Check if this is a level 2 menu item (has submenu-trigger class)
			if (item.classList.contains("submenu-trigger")) {
			} else {
				// Level 1 menu behavior
				gsap.to(subMenus, { y: "-100%" });
				gsap.set(subMenuContainers, { autoAlpha: 0 });
				gsap.to(subMenu, { y: 0, autoAlpha: 1, duration: 0.5 });
				gsap.fromTo(
					subMenuContainers,
					{ autoAlpha: 0 },
					{ autoAlpha: 1, delay: 0.4, duration: 0.3 }
				);
			}
		});
	});

	document.addEventListener("click", function (e) {
		if (!navigationBar.contains(e.target)) {
			if (navigationBar.dataset.state == "open") closeMainMenu();
		}
	});
	backmenu.forEach((button) => {
		button.addEventListener("click", function (e) {
			gsap.to(subMenus, { autoAlpha: 0 });
			gsap.to("#main-menu", { scrollTo: 0 }); // Scroll main menu back to top
			gsap.to('[data-target="mobile_menu"]', { scrollTo: 0 }); // Scroll mobile menu back to top
		});
	});
	if (mqlg.matches) {
	} else {
		gsap.set(menu_bar, { autoAlpha: 0 });
	}
	function closeMainMenu() {
		gsap.to(subMenus, { y: "-100%", duration: 0.5, delay: 0.1 });
		gsap.to('[data-name="main-menu__sub"] .menu_inside', {
			autoAlpha: 0,
			duration: 0.1,
		});
		if (mqlg.matches) {
		} else {
			gsap.to(mobile_menu, { y: "-110%", duration: 0.5, delay: 0.2 });
			gsap.to(menu_bar, { autoAlpha: 0, duration: 0.2 });
		}

		hamburgerCloseTL.play(0);
		navigationBar.dataset.state = "closed";
	}
	function openMainMenu() {
		hamburgerTL.play(0);
		gsap.to(mobile_menu, { y: 0, duration: 1 });
		gsap.to(menu_bar, { autoAlpha: 1, duration: 0.2, delay: 0.8 });
		navigationBar.dataset.state = "open";
	}

	let hamburgerTL = new gsap.timeline({
		defaults: { ease: "power2.inOut", duration: 0.2 },
		paused: true,
	});

	hamburgerTL
		.to(hamburgerSlices[0], { y: "8.5px" }, "start")
		.to(hamburgerSlices[2], { y: "-8.5px" }, "start")
		.to(hamburgerSlices[1], { opacity: 0, duration: 0.02 })
		.addLabel("rotate")
		.to(hamburgerSlices[0], { rotate: "45deg" }, "rotate")
		.to(hamburgerSlices[2], { rotate: "-45deg" }, "rotate");

	let hamburgerCloseTL = new gsap.timeline({
		defaults: { ease: "power2.inOut", duration: 0.2 },
		paused: true,
	});

	hamburgerCloseTL
		.to(hamburgerSlices[0], { y: "0" }, "start")
		.to(hamburgerSlices[2], { y: "0" }, "start")
		.to(hamburgerSlices[0], { rotate: "0" }, "start")
		.to(hamburgerSlices[2], { rotate: "0" }, "start")
		.to(hamburgerSlices[1], { opacity: 1, duration: 0.02 });

	document.addEventListener("click", function (e) {
		if (!mainMenu.contains(e.target) && !mainMenuToggle.contains(e.target)) {
			if (navigationBar.dataset.state == "open") closeMainMenu();
		}
	});

	mainMenuToggle.addEventListener("click", () => {
		if (navigationBar.dataset.state == "closed") {
			openMainMenu();
		} else {
			closeMainMenu();
		}
	});

	// Add handler for back-to-level2 buttons
	const backToLevel2Buttons = $qsa('[data-target="back-to-level2"]');
	backToLevel2Buttons.forEach((button) => {
		button.addEventListener("click", function (e) {
			// Hide all level 3 submenus
			const level3Submenus = $qsa(".level-3-submenu");
			gsap.to(level3Submenus, {
				autoAlpha: 0,
				duration: 0.3,
			});
		});
	});
}

export default menu;
